module.exports = __webpack_public_path__ + "img/couples_17_V.b748fb1d.webp";